<template>
  <div class="home-page">
    <HomeWidgets v-if="viewModel.isAuthorized"/>
    <div class="home-page__alerts" v-if="!!viewModel.cmsResources.notification">
      <Alerts :notification="viewModel.cmsResources.notification" />
    </div>
    <div class="home-page__content">
      <div class="home-page__news">
        <div v-if="!!viewModel.dailyOfferBanner" class="home-page__daily-offer">
          <a :href="viewModel.dailyOfferBanner.items[0].targetUrl">
            <img :src="viewModel.dailyOfferBanner.items[0].imageUrl" alt="">
          </a>
        </div>
        <News
          :main-news="viewModel.mainNews"
          :agency-news="agencyNews"
          :show-agency-news-tab="viewModel.showAgencyNewsTab"
          :news-page-url="viewModel.newsPageUrl"
        />
      </div>
      <div class="home-page__content-wrapper">
        <div class="home-page__slider">
          <Advertising
            :slider="viewModel.promoSlider"
            :promo="viewModel.promoLinksSlider"
          />
        </div>
        <div class="home-page__best-offers">
          <BestOffers />
        </div>
        <div v-if="viewModel.bottomSlider && !viewModel.bottomSlider.sliderNotFound" class="home-page__slider">
          <AdvertisingBottomSlider
            :slider="viewModel.bottomSlider"
          />
        </div>
        
        <div
          v-if="!!viewModel.promos && viewModel.promos.items.length > 0"
          class="home-page__promos"
        >
          <div class="block">
            <div class="block__title headings-font-family">
              {{ $res.General.Promotions }}
            </div>
            <Promos v-if="!!viewModel.promos" :promos="viewModel.promos" />
            <div v-else class="data-waiting-animation"></div>
          </div>
        </div>
      </div>
    </div>
    <notification-box ref="notificationBox"></notification-box>
  </div>
</template>

<script>
import News from "./news/NewsComponentDesktop.vue";
import Promos from "./promos/PromosComponentDesktop.vue";
import BestOffers from "./bestOffers/BestOffersComponentDesktop.vue";
import Alerts from "@/common/alerts/AlertsComponent.vue";
import Advertising from "./advertising/AdvertisingComponentDesktop.vue";
import AdvertisingBottomSlider from "./advertisingBottomSlider/AdvertisingBottomSliderDesktop.vue";
import StartsTodayWidget from "./widgets/StartsTodayWidgetComponentDesktop.vue";
import HomeWidgets from "./widgets/HomeWidgetsDesktop.vue";
import { delay, retryAsyncFunction } from "@/common/util/promises";
import { post } from "@/common/fetch";
import eventBus from "@/common/eventbus";
import NotificationBox from "@/common/modal/NotificationBoxDesktop.vue";

export default {
  components: {
    NotificationBox,
    News,
    Promos,
    Alerts,
    BestOffers,
    Advertising,
    StartsTodayWidget,
    HomeWidgets,
    AdvertisingBottomSlider
  },
  props: {
    viewModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      agencyNews: {
        newsList: []
      }
    };
  },
  created() {
    if (!this.isPromosLoaded(this.viewModel.promos)) {
      delay(1000).then(() => this.fetchPromos());
    }
  },
  mounted() {
    eventBus.$on("notification-box:open", this.showNotificationBox);
    this.fetchAgencyNews();
    document.addEventListener('tour-operator-office:change',this.fetchAgencyNews);
  },
  beforeDestroy() {
    document.removeEventListener('tour-operator-office:change',this.fetchAgencyNews);
    eventBus.$off("notification-box:open", this.showNotificationBox);
  },
  methods: {
    showNotificationBox: function (showParameters) {
      this.$refs.notificationBox.show(showParameters);
    },
    fetchAgencyNews() {
      post("/Home/GetRegionalNews", {}, true).then(serviceResult => {
        if (serviceResult.newsList) {
          this.agencyNews.newsList = serviceResult.newsList;
        }
      })
    },
    fetchPromos() {
      retryAsyncFunction(
        10,
        1000,
        (res) => this.isPromosLoaded(res),
        () => post("/Home/GetPromos", {}, true)
      )
        .then((res) => {
          this.viewModel.promos = res;
        });
    },

    isPromosLoaded(value) {
      return !!value;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  > * + * {
    margin-top: 20px;
  }
}

.home-page__content {
  display: flex;
  gap: 24px;
}

.home-page__news {
  flex: 0 0 auto;
  width: 264px;
}

.home-page__content-wrapper {
  flex: 1 1 0;
  > * + * {
    margin-top: 30px;
  }
}

.block {
  .data-waiting-animation {
    height: 180px;
  }
}

.block__title {
  margin-bottom: 20px;
  font-size: 28px;
  line-height: 44px;
  font-weight: 600;
}

.home-page__daily-offer {
  margin-bottom: 10px;
  
  img {
    width: 264px;
    height: 192px;
    border-radius: 14px;
    object-fit: cover;
  }
}
</style>




